import { FormControlLabel, Paper, Radio, RadioGroup, Grid } from '@material-ui/core';
import CustomButton from 'components/CustomInput/Button';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import useDialog from 'components/ConfirmDialog/useDialog';
import { ADD_MEETING_ARRANGEMENT_REVIEWER_RESULT, GET_TYPEOFREVIEW } from 'store/key';
import { CREATED_CONFIRM_RESULT } from 'utility/frontendMessage';
import useQuery from 'hooks/useQuery';
import useConfirmReviewResultData from './useConfirmReviewResultData';
import CustomRadio from 'components/CustomRadio';

const SLayout = styled.div`
    padding: 20px;
`;

const SRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const ConfirmResult = (props) => {
    const appId = useQuery('appId');
    const documentType = Number(useQuery('documentType'));
    const history = useHistory();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    
    const [choices, setChoices] = useState([])
    const [decision, setDecision] = useState('');
    const [comment, setComment] = useState('');
    const [shareComment, setShareComment] = useState(null);
    const [declaration, setDeclaration] = useState(false);
    const [relationships, setRelationships] = useState('');
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [forceErrorDisplay, setForceErrorDisplay] = useState(false);
    const [decisionValid, setDecisionValid] = useState(true);
    const [shareCommentValid, setShareCommentValid] = useState(true);

    const { getChoicesList } = useConfirmReviewResultData();

    useEffect(() => {
        if (appId) {
            dispatch({
                type: GET_TYPEOFREVIEW,
                payload: {
                    params: { id: appId, documentType: documentType },
                    callback: (res) => {
                        const { typeOfReview, canConfirmReviewResult, reviewerResult } = res
                        const list = getChoicesList(documentType, typeOfReview);
                        setChoices(list);
                        setIsViewOnly(!canConfirmReviewResult);

                        if (reviewerResult) {
                            setDecision(reviewerResult.decision);
                            setComment(reviewerResult.comment);
                            setShareComment(reviewerResult.shareComment);
                            setDeclaration(reviewerResult.declaration);
                            setRelationships(reviewerResult.relationships);
                        }
                    },
                },
            });
        }
    }, [appId])
    
    const handleSave = () => {
        setForceErrorDisplay(true);
        let data = {
            documentId: appId,
            decision,
            comment,
            shareComment,
            declaration,
            relationships,
            documentType,
        }
        if ((declaration && !relationships) || !decisionValid || !shareCommentValid) {
            return
        }
        if (comment.length > 1000 || relationships.length > 1000) return
        dispatch({
            type: ADD_MEETING_ARRANGEMENT_REVIEWER_RESULT,
            payload: {
                data,
                callback: () => {
                    showDialog({
                        description: CREATED_CONFIRM_RESULT,
                        disableCancelButton: true,
                    });
                    history.push('/')
                },
            },
        });
    }
    return (
        <SLayout>
            <SRow>
                <div>
                    {!isViewOnly && <CustomButton style={{ marginRight: 20 }} onClick={handleSave}>
                        Submit
                    </CustomButton>}
                    <CustomButton type="cancel" onClick={() => {
                        history.goBack()
                    }}>
                        Back
                    </CustomButton>
                </div>
                {isViewOnly && <div style={{fontSize: 16, fontWeight: 'bold'}}>
                    View Only
                </div>}
            </SRow>
            <TextSubHeader style={{ marginTop: 20 }}>Please provide your comment if needed</TextSubHeader>
            <div style={{ marginTop: 15, width: 500 }}>
                <CustomOutlineSelect
                    value={decision}
                    onChange={(e) => setDecision(e.target.value)}
                    choices={choices}
                    disabled={isViewOnly}
                    isRequired
                    forceErrorDisplay={forceErrorDisplay}
                    isValidValue={(isValid) => setDecisionValid(isValid)}
                />
            </div>
            <div style={{ marginTop: 20, width: 500 }}>
                <CustomTextField
                    value={comment}
                    isTextArea
                    textAreaMinRow={6}
                    label={'Comments'}
                    onChange={(e) => setComment(e.target.value)}
                    maxLength={1000}
                    disabled={isViewOnly}
                />
            </div>

            <SRow style={{ marginTop: 15 }}>
                <Grid container wrap='nowrap' alignItems='center' style={{ marginLeft: 10 }}>
                    I am willing to share this decision/comment to all reviewers
                    <div style={{ marginLeft: 10, display: 'flex', alignItems: 'center'}}>
                        <CustomRadio
                            isRequired
                            forceErrorDisplay={forceErrorDisplay}
                            isValidValue={(isValid) => setShareCommentValid(isValid)}
                            disabled={isViewOnly}
                            onChange={(e) => {
                                setShareComment(JSON.parse(e.target.value));
                            }}
                            value={shareComment}
                            operators={[
                                {
                                    key: true,
                                    label: 'Yes',
                                },
                                {
                                    key: false,
                                    label: 'No',
                                },
                            ]}
                        />
                    </div>
                </Grid>
            </SRow>
            <Paper style={{ marginTop: 20 }}>
                <TextSubHeader style={{ background: '#1F497D', color: 'white', padding: '10px', textAlign: 'center' }}>
                    Declare Conflict of Interest
                </TextSubHeader>
                <div style={{ padding: 15 }}>
                    <SRow>
                        <RadioGroup
                            value={declaration}
                            onChange={(e) => {
                                setDeclaration(JSON.parse(e.target.value));
                                if (!JSON.parse(e.target.value)){
                                    setRelationships('')
                                }
                            }}
                        >
                            <FormControlLabel
                                value={false}
                                control={<Radio size='small' disabled={isViewOnly} color='primary' />}
                                label="I have no conflict of interest currently, and will report such relationships to the [REC/IRB] if
                            it should arise during the course of review.
                        "
                            />
                            <FormControlLabel
                                value={true}
                                control={<Radio size='small' disabled={isViewOnly} color='primary' />}
                                label="The following relationship(s) for your assessment of conflict of interest:"
                            />
                        </RadioGroup>
                    </SRow>

                    <SRow style={{ marginTop: 20 }}>
                        <CustomTextField
                            onChange={(e) => setRelationships(e.target.value)}
                            value={relationships}
                            isTextArea
                            textAreaMinRow={6}
                            label={'Relationships'}
                            maxLength={1000}
                            disabled={!declaration || isViewOnly}
                            forceErrorDisplay={forceErrorDisplay}
                            validators={!declaration ? [] : ['isRequired']}
                        />
                    </SRow>
                </div>
            </Paper>
        </SLayout>
    );
};

export default ConfirmResult;
